import React, { useState, useEffect } from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Form,
  FormGroup,
  Label,
  Row,
  Col,
  Input,
} from "reactstrap";
import Select from "react-select";
import { toast } from 'react-hot-toast';

export const EditStatus = ({
  isOpen,
  toggle,
  selectedOrder,
  status,
  setStatus,
  onSave,
}) => {
  const [remarks, setRemarks] = useState("");
  const [isDisabled, setIsDisabled] = useState(false);

  const statusOptions = [
    { label: "Ongoing", value: 1 },
    { label: "Billing", value: 2 },
    { label: "Cancelled", value: 3 },
    { label: "Completed", value: 4 },
  ];

  const selectedOption = statusOptions.find((option) => 
    option.label.toLowerCase() === (selectedOrder?.billingStatus || '').toLowerCase()
  ) || statusOptions[0];

  useEffect(() => {
    if (isOpen) {
      setRemarks("");
      
      setStatus(selectedOption.value);
      
      const isCompletedStatus = selectedOrder?.billingStatus?.toLowerCase() === 'completed';
      setIsDisabled(isCompletedStatus);
      
      if (isCompletedStatus) {
        toast.error("Completed status cannot be modified");
      }
    }
  }, [isOpen, selectedOrder]);

  const handleStatusChange = (selected) => {
    if (isDisabled) {
      toast.error("Completed status cannot be modified");
      return;
    }
    
    setStatus(selected.value);
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle} backdrop={true}>
      <ModalHeader toggle={toggle}>Edit Billing Status</ModalHeader>
      <ModalBody>
        {selectedOrder && (
          <Form>
            <Row className="mb-3">
              <Col>
                <div className="border rounded p-3 bg-light">
                  <h6 className="mb-2">Order Details</h6>
                  <p className="mb-1">
                    <strong>Order Ref:</strong> {selectedOrder.orderRef}
                  </p>
                  <p className="mb-1">
                    <strong>Current Billing Status:</strong> {selectedOrder.billingStatus}
                  </p>
                  <p className="mb-0">
                    <strong>Created Date:</strong> {new Date(selectedOrder.createdDate).toLocaleString()}
                  </p>
                </div>
              </Col>
            </Row>
            <FormGroup>
              <Label for="billingStatus">Billing Status</Label>
              <Select
                id="billingStatus"
                name="billingStatus"
                options={statusOptions}
                value={statusOptions.find(option => option.value === status)}
                onChange={handleStatusChange}
                placeholder="Select a status"
                isSearchable={true}
                isDisabled={isDisabled}
                styles={{
                  control: (provided) => ({
                    ...provided,
                    border: "1px solid #ced4da",
                    borderRadius: "4px",
                    minHeight: "38px",
                    backgroundColor: isDisabled ? '#e9ecef' : 'white'
                  }),
                  option: (provided, state) => ({
                    ...provided,
                    backgroundColor: state.isSelected ? "#5B71B9" : "white",
                    color: state.isSelected ? "white" : "black",
                  }),
                }}
              />
            </FormGroup>
            <FormGroup>
              <Label for="remarks">Remarks</Label>
              <Input
                id="remarks"
                name="remarks"
                type="textarea"
                value={remarks}
                onChange={(e) => setRemarks(e.target.value)}
                placeholder="Enter remarks"
                disabled={isDisabled}
              />
            </FormGroup>
          </Form>
        )}
      </ModalBody>
      <ModalFooter>
        <Button
          color="primary"
          onClick={() => onSave(remarks)}
          disabled={isDisabled}
        >
          Save Changes
        </Button>
        <Button color="secondary" onClick={toggle}>
          Cancel
        </Button>
      </ModalFooter>
    </Modal>
  );
};